import { createModule, startNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Jspreadsheet from 'Jspreadsheet-ce';
import 'friendly-challenge/widget';
import * as Widget from 'friendly-challenge';

let sheetElm = <HTMLDivElement>document.getElementById('spreadsheetTable');
let Container = <HTMLDivElement>document.getElementById('captcha');
let initSpreadsheet: any;
const regexInvoiceDate = new RegExp(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/);
const regexInvoiceNum = new RegExp(/^(?=.{0,16}$)[a-zA-Z0-9 \/!@#\$%\^\&*\)\(\{\}\'\"\\+=._-]+$/);
const regexInvoiceAmu = new RegExp(/^(?=.{0,13}$)^-?[1-9]\d*(\.\d+)?$/);
let IsError: boolean = false;
let valCell: any;
let valRow: any;
let valValue: any;
let valCol: any;
let isSearch: boolean = false;

const _global = window as any;
_global.callBack = callBack;

const classes = {
	searchBtn: 'inquiry-portal__search-button',
	stateLoadingIndicatorHide: 'state-m-invoice-table__loading--hidden',
	contentLoading: 'js-content-loading',
	loadModalOverlay: 'm-modal-overlay',
	loadModalOverlayVisible: 'state-m-modal-overlay--visible',
	resetBtn: 'inquiry-portal__reset-button',
	addRow: 'm-invoice-table-content__add-btn',
	deleteRow: 'm-invoice-table-content__delete-btn',
	captchaBtn: 'frc-container',
};

interface IInvoiceLabeldata {
	invoiceNumber: string;
	invoiceDate: string;
	billingAmount: string;
	paymentDueDate: string;
	invoiceStatus: string;
	actionColumn: string;
}

interface IApiData {
	invoiceNumber: string;
	invoiceDate: string;
	billingAmount: string;
	paymentDueDate?: string;
	invoiceStatus?: string;
	isError?: boolean;
}

let sheetDataGlobal: IApiData[] = [
	{
		invoiceNumber: '',
		invoiceDate: '',
		paymentDueDate: '',
		billingAmount: '',
		invoiceStatus: '',
		isError: false,
	},
];

let invoiceInquiryLabels: IInvoiceLabeldata;

@createModule('InvoiceTable')

/**
 * invoice-table module implementation.
 */
export class InvoiceTable extends TerrificSpec {
	$ctx: JQuery<HTMLElement>;
	tableBodyEle: JQuery<HTMLElement>;	
	searchButtonEle: JQuery<HTMLElement>;
	cellInputEle: JQuery<HTMLElement>;
	sheetData: any = [];
	data: any = [];
	invoiceData: any = [];
	iapiData: IApiData;
	contentLoadingEle: JQuery<HTMLElement>;
	loadModalOverlayEle: JQuery<HTMLElement>;
	resetButtonEle: JQuery<HTMLElement>;
	deleteRowEle: JQuery<HTMLElement>;
	addRowEle: JQuery<HTMLElement>;
	CaptchaEle: JQuery<HTMLElement>;

	async start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.tableBodyEle = this.$ctx.find('#spreadsheetTable');
		invoiceInquiryLabels = this.$ctx.data() as IInvoiceLabeldata;
		this.initInvoiceSheet(sheetDataGlobal, false);
		this.searchButtonEle = this.$ctx.find(`.${classes.searchBtn}`);
		this.CaptchaEle = this.$ctx.find(`.${classes.captchaBtn}`);
		this.searchButtonEle.on('click', this.getinvoicedatafromapi.bind(this));
		this.contentLoadingEle = this.$ctx.find(`.${classes.contentLoading}`);
		this.loadModalOverlayEle = $(`.${classes.loadModalOverlay}`);
		this.searchButtonEle.attr('disabled', 'true');
		//this.addDeleteRow();
		this.resetButtonEle = this.$ctx.find(`.${classes.resetBtn}`);
		this.resetButtonEle.attr('disabled', 'true');
		this.resetButtonEle.on('click', this.resetSpreadSheet.bind(this));
		this.deleteRowEle = this.$ctx.find(`.${classes.deleteRow}`);
		this.deleteRowEle.addClass('__disabled-btn');
		this.deleteRowEle.on('click', this.DeleteRow.bind(this));
		this.addRowEle = this.$ctx.find(`.${classes.addRow}`);
		this.addRowEle.on('click', this.AddRow.bind(this));
		this.AddDeleteRow();
		resolve();
	}
	stop() { }

	initInvoiceSheet(invoiceData: any, updateData: boolean) {
		if (updateData) {
			initSpreadsheet.setData(invoiceData);
		} else {
			initSpreadsheet = Jspreadsheet(sheetElm, {
				tableOverflow: true,
				tableHeight: '500px',
				allowInsertRow: true,
				allowManualInsertRow: true,
				allowInsertColumn: false,
				allowManualInsertColumn: false,
				allowDeleteRow: true,
				allowDeleteColumn: false,
				allowRenameColumn: false,
				allowComments: false,
				columnSorting: false,
				columnResize: true,
				data: invoiceData,
				minDimensions: [4, 1],
				csvHeaders: true,
				columns: [
					{
						type: 'text',
						title: invoiceInquiryLabels.invoiceNumber,
						width: 140,
						name: 'invoiceNumber',
					},
					{
						type: 'numeric',
						title: invoiceInquiryLabels.invoiceDate,
						width: 130,
						mask: 'YYYY-MM-DD',
						name: 'invoiceDate',
					},
					{
						type: 'text',
						title: this.extractTextFromHTML(invoiceInquiryLabels.billingAmount.trim()),
						width: 260,
						mask: '0.00',
						decimal: '.',
						name: 'billingAmount',
						
					},
					{
						title: invoiceInquiryLabels.paymentDueDate,
						width: 130,
						name: 'paymentDueDate',
						readOnly: true,
					},
					{
						title: invoiceInquiryLabels.invoiceStatus,
						width: 190,
						name: 'invoiceStatus',
						readOnly: true,
					},
					{ title: ' ', type: 'text', width: 50, name: 'alterRow' },
				],
				
				onafterchanges: function () {
					// @ts-ignore
					this.sheetData = initSpreadsheet.getJson();
					sheetDataGlobal = initSpreadsheet.getJson();
				},
				oninsertrow: function () {
					if (sheetDataGlobal.length > 30) {
						this.sheetData.length = 30;
						initSpreadsheet.setData(this.sheetData);
					}
				},
			
				onload: function () {
					setTimeout(() => {
						const tableHeader = document.querySelector("[data-x='2']");
						tableHeader.innerHTML =  invoiceInquiryLabels.billingAmount.trim();
					}, 100);
				},				

				updateTable: function (el, cell, x, y, source, value, id) {
					valCell = cell;
					valRow = x;
					valValue = value;
					valCol = y;

					if (isSearch) {
						if (valValue === '' && valRow < 3) {
							valCell.classList.add('error');
							IsError = true;
						} else {
							if (valRow == 0) {
								if (regexInvoiceNum.test(valValue)) {
									$(valCell).removeClass('error');
									IsError = false;
								} else {
									valCell.classList.add('error');
									IsError = true;
								}
							}
							if (valRow == 1) {
								if (regexInvoiceDate.test(valValue)) {
									$(valCell).removeClass('error');
									IsError = false;
								} else {
									valCell.classList.add('error');
									IsError = true;
								}
							}
							if (valRow == 2) {
								if (regexInvoiceAmu.test(valValue)) {
									$(valCell).removeClass('error');
									IsError = false;
								} else {
									valCell.classList.add('error');
									IsError = true;
								}
							}
							if (value == 'true') {
								$(cell)
									.parent()
									.addClass('errortext');
							} else {
								$(cell)
									.parent()
									.removeClass('errortext');
							}
						}
					}
					if (x == 5) {
						$(cell).html(
							` <button title="Delete" type="button" class="m-invoice-table m-invoice-table-content__delete-btn"> </button>`
						);
					}
				},
			});
		}
	}
	// Function to extract text from HTML
	extractTextFromHTML(html:string):string  {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const textContent = doc.body.textContent.replace(/<br\s*\/?>/g, '\n'); // Convert <br> and <br/> to newline
		return textContent;
	}
	
	validation(row: any, cell: any, adderrorclass: boolean) {
		let rownum = row + 1;
		if (adderrorclass) {
			$('.jexcel tr:eq(' + rownum + ') td:eq(' + cell + ')').addClass('error');
		} else {
			$('.jexcel tr:eq(' + rownum + ') td:eq(' + cell + ')').removeClass('error');
		}
	}

	validate(): boolean {
		var result = false;
		let sheetDatalocal: Array<IApiData> = sheetDataGlobal;

		sheetDatalocal.forEach((object) => {
			delete object['paymentDueDate'];
			delete object['invoiceStatus'];
		});
		let data = sheetDatalocal;

		data.forEach((row, index) => {
			if (
				row.billingAmount === '' ||
				row.billingAmount === undefined ||
				!regexInvoiceAmu.test(row.billingAmount)
			) {
				this.validation(index, 3, true);
			} else {
				this.validation(index, 3, false);
			}

			if (row.invoiceDate === '' || row.invoiceDate === undefined) {
				this.validation(index, 2, true);
			} else {
				this.validation(index, 2, false);
			}

			if (
				row.invoiceNumber === '' ||
				row.invoiceNumber === undefined ||
				!regexInvoiceNum.test(row.invoiceNumber)
			) {
				this.validation(index, 1, true);
			} else {
				this.validation(index, 1, false);
			}
			var errorClass = this.tableBodyEle.find(`.${'error'}`);

			if (
				row.billingAmount === '' ||
				row.invoiceDate === '' ||
				row.invoiceNumber === '' ||
				errorClass.length > 0
			) {
				result = false;
			} else {
				result = true;
			}
		});
		return result;
	}

	getinvoicedatafromapi() {
		isSearch = true;

		if (!IsError && this.validate()) {
			this.showContentLoading();
			const apiEndpoint = '/api/invoiceinquiry/post';
			let sheetDatalocal: Array<IApiData> = sheetDataGlobal;
			sheetDatalocal.forEach((object) => {
				delete object['paymentDueDate'];
				delete object['invoiceStatus'];
				delete object['isError'];
			});
			let data = sheetDatalocal;
			$.ajax({
				type: 'POST',
				url: apiEndpoint,
				contentType: 'application/json',
				dataType: 'json',
				data: JSON.stringify(data),
				traditional: true,

				success: (response: any) => {
					this.initInvoiceSheet(response.responseitems, true);
					this.hideContentLoading();
					const widget = new Widget.WidgetInstance(Container, {
						startMode: 'none',
					});
					widget.reset();
					isSearch = false;
					this.searchButtonEle.attr('disabled', 'true');
				},
				error: (xhr: any, status: string, error: string) => {
					console.log(`get invoice data error, ${xhr.status}, ${xhr.statusText}, ${error}`);
					this.hideContentLoading();
				},
			});
		}
	}

	showContentLoading() {
		this.contentLoadingEle.removeClass(classes.stateLoadingIndicatorHide);
		this.loadModalOverlayEle.addClass(classes.loadModalOverlayVisible);
	}

	hideContentLoading() {
		this.contentLoadingEle.addClass(classes.stateLoadingIndicatorHide);
		this.loadModalOverlayEle.removeClass(classes.loadModalOverlayVisible);
	}

	resetSpreadSheet() {
		let invoiceData: any = [];
		initSpreadsheet.setData(invoiceData);
		sheetDataGlobal = initSpreadsheet.getJson();
	}

	DeleteRow(e: any) {
		e.preventDefault();
		let rowIn = $(this)
			.parent()
			.data('y');
		initSpreadsheet.deleteRow(rowIn, 0);
	}

	AddRow(e: any) {
		e.preventDefault();
		this.deleteRowEle.removeClass('__disabled-btn');
		let rowIn = $(this)
			.parent()
			.data('y');
		initSpreadsheet.insertRow(0, rowIn);
	}

	AddDeleteRow() {
		$('body').on('click', '.m-invoice-table-content__add-btn', function (e: any) {
			e.preventDefault();
			let rowNumIn = $(this)
				.parent()
				.data('y');
			initSpreadsheet.insertRow(0, rowNumIn);
			sheetDataGlobal = initSpreadsheet.getJson();
		});

		$('body').on('click', '.m-invoice-table-content__delete-btn', function (e: any) {
			e.preventDefault();
			let rowIn = $(this)
				.parent()
				.data('y');
			initSpreadsheet.deleteRow(rowIn, 0);
			sheetDataGlobal = initSpreadsheet.getJson();
		});
	}
}

function callBack(solution: string) {
	let data = { captchasolution: solution };

	$.ajax({
		type: 'POST',
		url: '/api/invoiceinquiry/captchaverification',
		contentType: 'application/json; charset=utf-8',
		dataType: 'json',
		data: JSON.stringify(data),
		success: function (response: any) {
			if (response == true) {
				$('.inquiry-portal__search-button').removeAttr('disabled');
				$('.inquiry-portal__reset-button').removeAttr('disabled');
			}
		},
		error: (xhr: any, status: string, error: string) => {
			console.log(`get captcha response error, ${xhr.status}, ${xhr.statusText}, ${error}`);
		},
	});
}
(window as any).callBack = callBack;
